import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductionWithheldManager } from '../../../../managers/production-withheld.manager';
import { ProductionJob } from '../../../../models/review/production-job.model';

@Component({
    selector: 'lex-download-production-withheld-dialog',
    templateUrl: './download-production-withheld-dialog.component.html',
    styleUrls: ['./download-production-withheld-dialog.component.scss'],
    standalone: false
})
export class DownloadProductionWithheldDialogComponent {

	public productionJob: ProductionJob;
	public isDownloadStarted: boolean = false;

	constructor(private withheldManager: ProductionWithheldManager,
		private dialogRef: MatDialogRef<DownloadProductionWithheldDialogComponent>,
		@Inject(MAT_DIALOG_DATA) data) {
		this.productionJob = data.productionJob;
	}

	public download() {
		this.isDownloadStarted = true;
		this.withheldManager.getDownloadWithheldLink(this.productionJob.productionJobId, this.productionJob.title)
			.subscribe(() => {
				this.isDownloadStarted = false;
				this.dialogRef.close(true);
			});
	}
}
